import { render } from "./HomeAdmin.vue?vue&type=template&id=8c15cb2e&scoped=true"
import script from "./HomeAdmin.vue?vue&type=script&lang=js"
export * from "./HomeAdmin.vue?vue&type=script&lang=js"

import "./HomeAdmin.vue?vue&type=style&index=0&id=8c15cb2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c15cb2e"]])

export default __exports__